import React from 'react';

interface MonitoringTabProps {
  reportData?: any;
}

const MonitoringTab: React.FC<MonitoringTabProps> = ({ reportData }) => {
  // Default data in case no report data is provided
  const primaryTreatment = reportData?.analysis_results?.treatment?.primary || {
    drug_name: "Meropenem",
    dosage: "1-2 gm",
    route: "IV",
    frequency: "q8h"
  };

  const monitoringRequirements = reportData?.analysis_results?.treatment?.precautions?.monitoring_requirements || [
    "Monitor for clinical response",
    "Assess for adverse drug reactions",
    "Monitor for GI (nausea, vomiting, diarrhea, C. difficile infection)",
    "Monitor for Hypersensitivity (rash, urticaria, anaphylaxis)",
    "Monitor for Local phlebitis"
  ];
  
  const alternativeTreatments = reportData?.analysis_results?.treatment?.drug_recommendations?.alternatives || [
    {
      name: "Ertapenem",
      dosage: "1 gm",
      route: "IV/IM",
      frequency: "q24h"
    },
    {
      name: "Imipenem-Cilastatin",
      dosage: "500 mg",
      route: "IV",
      frequency: "q6h"
    },
    {
      name: "Meropenem-Vaborbactam",
      dosage: "4 gram",
      route: "IV",
      frequency: "q8h"
    }
  ];

  // Helper function to get importance level
  const getImportance = (requirement: string) => {
    if (requirement.includes("clinical response") || 
        requirement.includes("adverse drug") || 
        requirement.includes("Hypersensitivity")) {
      return "High";
    } else if (requirement.includes("Unknown")) {
      return "Medium";
    } else {
      return "High";
    }
  };

  return (
    <div className="p-6">
      <div className="mb-8">
        {/* Monitoring Requirements Section */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-text mb-4">Monitoring Requirements</h3>
          <p className="mb-4 font-medium">Primary Treatment: {primaryTreatment.drug_name}</p>
          
          <div className="space-y-6">
            {monitoringRequirements.map((requirement: string, index: number) => (
              <div key={index} className="ml-8">
                <p className="font-medium mb-1">{requirement}</p>
                <p className="text-sm text-gray-600">
                  Frequency: Regular, Importance: {getImportance(requirement)}
                </p>
              </div>
            ))}
            
            <div className="ml-8">
              <p className="font-medium mb-1">Unknown</p>
              <p className="text-sm text-gray-600">
                Frequency: Regular, Importance: Medium
              </p>
            </div>
          </div>
        </div>

        {/* Alternative Treatments Monitoring */}
        <div>
          <h3 className="text-lg font-semibold text-text mb-4">Alternative Treatments Monitoring</h3>
          <div className="overflow-x-auto">
            <table className="min-w-full border-collapse">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="py-2 px-4 text-left font-medium w-1/3">Treatment</th>
                  <th className="py-2 px-4 text-left font-medium w-2/3">Monitoring Requirements</th>
                </tr>
              </thead>
              <tbody>
                {alternativeTreatments.map((treatment: any, index: number) => (
                  <tr key={index} className="border-b border-gray-200">
                    <td className="py-3 px-4 align-top">{treatment.name}</td>
                    <td className="py-3 px-4">Standard monitoring of CBC, LFTs, and clinical response.</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonitoringTab; 